/* Make the mobile fullscreen PDP gallery behave like the inline gallery by
   wrapping from the final image to the first, and vice versa. */
(function () {
  const mobileViewport = window.matchMedia('(max-width: 999px)');

  window.customElements.whenDefined('product-image-zoom').then(() => {
    const ProductImageZoom = window.customElements.get('product-image-zoom');
    const prototype = ProductImageZoom?.prototype;

    if (!prototype || prototype.friendsMobileLoopEnabled || typeof prototype._openPhotoSwipe !== 'function') {
      return;
    }

    const openPhotoSwipe = prototype._openPhotoSwipe;

    prototype._openPhotoSwipe = async function (...args) {
      const PhotoSwipe = window.ThemePhotoSwipe;

      if (!mobileViewport.matches || typeof PhotoSwipe !== 'function') {
        return openPhotoSwipe.apply(this, args);
      }

      function FriendsLoopingPhotoSwipe(template, UiClass, items, options) {
        const shouldLoop = items.length > 1;

        return new PhotoSwipe(template, UiClass, items, {
          ...options,
          loop: shouldLoop,
          allowPanToNext: shouldLoop
        });
      }

      FriendsLoopingPhotoSwipe.prototype = PhotoSwipe.prototype;
      window.ThemePhotoSwipe = FriendsLoopingPhotoSwipe;

      try {
        await openPhotoSwipe.apply(this, args);

        /* PhotoSwipe 4 disables its loop option during initialization when
           there are only two images. Restore it and explicitly populate both
           adjacent holders with the other image. */
        if (this.photoSwipeInstance?.items.length > 1) {
          const enableLoop = () => {
            const instance = this.photoSwipeInstance;

            instance.options.loop = true;
            instance.options.allowPanToNext = true;

            if (instance.items.length === 2 && typeof instance.setContent === 'function') {
              const currentIndex = instance.getCurrentIndex();

              instance.setContent(instance.itemHolders[0], currentIndex - 1);
              instance.setContent(instance.itemHolders[2], currentIndex + 1);
            }
          };

          enableLoop();
          this.photoSwipeInstance.listen('initialZoomInEnd', enableLoop);
        }
      } finally {
        if (window.ThemePhotoSwipe === FriendsLoopingPhotoSwipe) {
          window.ThemePhotoSwipe = PhotoSwipe;
        }
      }
    };

    prototype.friendsMobileLoopEnabled = true;
  });
})();
